"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmSetLocationModal = void 0;
const React = require("react");
const dialogs_1 = require("../../../../../types/dialogs");
const Modal_1 = require("../../../../../components/base/structure/Modal");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "ConfirmSetLocationModal");
const ConfirmSetLocationModal = ({ open, setOpen }) => {
    return (React.createElement(Modal_1.Modal, { open: open, size: dialogs_1.TDialogSizes.Small, onClose: () => setOpen(false), closeOnEsc: true, closeOnOverlayClick: true, showCloseIcon: true },
        React.createElement(Modal_1.ModalHeader, null, "Location missing"),
        React.createElement(Modal_1.ModalBody, null,
            React.createElement("div", { className: css("") },
                React.createElement("p", { className: css("message") }, "Please set your location to continue. If you are having any issues please check your browser location settings.")))));
};
exports.ConfirmSetLocationModal = ConfirmSetLocationModal;
//# sourceMappingURL=index.js.map